import { render } from "./cell_technicsinfolist.vue?vue&type=template&id=57b5e0c4"
import script from "./cell_technicsinfolist.vue?vue&type=script&lang=ts"
export * from "./cell_technicsinfolist.vue?vue&type=script&lang=ts"
script.render = render

export default script